import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const Cycle8 = () => (
  <ArticleWrapper articleId="cycle8">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Cycle8</h1>
        <img src="/pictures/gallery/gallery2.JPG" alt="Cycle8" className="rounded-lg mb-6" />
        {/* Add your Cycle8 article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default Cycle8;
